import { v7 as uuidv7, v4 as uuidv4 } from 'uuid';

/**
 * Ідентифікатор спроби генерується НА КЛІЄНТІ до будь-якої мережевої дії.
 * Саме він робить відправку ідемпотентною: скільки б разів черга не
 * повторила запит, сервер запише спробу один раз (`ON CONFLICT DO NOTHING`).
 *
 * UUIDv7 обраний свідомо — він монотонний у часі, тому спроби природно
 * лежать у порядку створення і пачки синхронізації йдуть хронологічно.
 */
export function newAttemptId(): string {
  return uuidv7();
}

/** Ключ ідемпотентності для операцій, де порядок не важливий (старт сесії, виплата). */
export function newIdempotencyKey(): string {
  return uuidv4();
}

export function newId(): string {
  return uuidv4();
}
